import type {JsonApiResponse} from "~/types/JsonApiResponse";
import type {GenreData} from "~/types/GenreData";

export interface SpiceLevel {
    value: number;
    label: string;
}

export const useSpiceLevels = () => {
    const getSpiceLevels = async () => {
        const {data} = await useAsyncData<JsonApiResponse<number[]>>("spice_levels", () => $api("/api/spice-levels"));

        const levels: SpiceLevel[] = [];
        if (data.value) {
            for (const level of data.value.data) {
                const label = spiceLabels[`spice${level}` as keyof typeof spiceLabels];
                if (label) {
                    levels.push(label);
                }
            }
        }

        return levels;
    };

    const spiceLabels = {
        "spice0": {
            "value": 0,
            "label": "-",
        },
        "spice1": {
            "value": 1,
            "label": spiceLevelLabel(0),
        },
        "spice2": {
            "value": 2,
            "label": spiceLevelLabel(1),
        },
        "spice3": {
            "value": 3,
            "label": spiceLevelLabel(2),
        },
    };

    return {
        getSpiceLevels,
    };
};

export const spiceLevelLabel = (level:number) => {
    const labels = ['Sexy', 'Hot', 'Extra-hot'];
    return labels[level] ?? '';
}
